import './style.css.js';
import { useClassNames } from '@magnetic/hooks';
import React, { memo, forwardRef } from 'react';

const Divider = memo(
  forwardRef(
    ({
      as,
      className,
      direction = "horizontal",
      size = "md",
      strong = false,
      ...rest
    }, ref) => {
      const Component = as != null ? as : "div";
      const classNames = useClassNames(
        "mds-divider",
        `mds-divider-size-${size}`,
        `mds-divider-direction-${direction}`,
        strong ? "mds-divider-intensity-strong" : "mds-divider-intensity-default",
        className
      );
      return /* @__PURE__ */ React.createElement(Component, {
        ...rest,
        "aria-orientation": direction,
        className: classNames,
        ref,
        role: "separator"
      });
    }
  )
);

export { Divider };
//# sourceMappingURL=index.js.map
